import type { IEnergyPassportDetails, IEnergyPassportProduct, IEnergyPassportResourceType } from "@/entities/energy-passport/types.ts"
import { generateTempId } from "@/shared/lib/helper-functions.ts"
import type { IQuarterNumber } from "@/shared/types/interfaces"

export const initialEnergyPassportProducts: IEnergyPassportProduct[] = [
  {
    nameError: true,
    quarter_number: 1,
    product_name: "",
    count: 0,
    count_measure: "тонн",
    active_energy: 0,
    reactive_energy: 0,
    thermal_energy: 0,
    gas: 0,
    mazut: 0,
    coal: 0,
    gasoline: 0,
    diesel: 0,
    kerosene: 0,
    // oils: 0,
    other_petroleum_products: 0,
    water: 0,
    is_main_product: true
  }
]

export const generateInitialEnergyPassportDetails = (energy_type: IEnergyPassportResourceType): IEnergyPassportDetails[] => {
  return Array.from({ length: 4 }).map((_, i) => ({
    tempId: generateTempId("details"),
    quarter: (i + 1) as IQuarterNumber,
    energy_type,
    declared_consumption: 0,
    sub_consumption: 0,
    total_consumption: 0,
    technical_needs: 0,
    own_needs: 0,
    production_needs: 0,
    residential_needs: 0,
    consumption_standard: 0,
    max_nominal_capacity_per_hour: 0
    // passport: 0
  }))
}
